import React from 'react';

//assets
import './link-strip.scss';

//components
import DynamicLink from 'components/dynamic_link';

export default function LinkStrip(props) {

    return (
        <section className="link-strip">
            <div className="text">{ props.data.title }</div>
            <DynamicLink data = { props.data.link } className="button">
                { props.data.btnText }
            </DynamicLink>
        </section>
    );
}
